/*
CSS Browser Selector js v0.5.3 (July 2, 2013)

-- original --
Rafael Lima (http://rafael.adm.br)
http://rafael.adm.br/css_browser_selector
  License: http://creativecommons.org/licenses/by/2.5/
    Contributors: http://rafael.adm.br/css_browser_selector#contributors
      -- /original --

Fork project: http://code.google.com/p/css-browser-selector/
  Song Hyo-Jin (shj at xenosi.de)
*/
function css_browser_selector(u) {
  var ua = u.toLowerCase(),
    is = function(t) {
      return ua.indexOf(t) > -1
    },
    g = 'gecko',
    w = 'webkit',
    s = 'safari',
    c = 'chrome',
    o = 'opera',
    m = 'mobile',
    v = 0,
    r = window.devicePixelRatio ? (window.devicePixelRatio + '').replace('.', '_') : '1';
  var res = [
    /* IE */
    (!(/opera|webtv/.test(ua)) && /msie\s(\d+)/.test(ua) && (v = RegExp.$1 * 1)) ?
      ('ie ie' + v + ((v == 6 || v == 7) ?
        ' ie67 ie678 ie6789' : (v == 8) ?
          ' ie678 ie6789' : (v == 9) ?
            ' ie6789 ie9m' : (v > 9 ) ?
              ' ie9m' : '')) :
      /* IE 11 */
      (/trident\/\d+.*?;\s*rv:(\d+)\.(\d+)\)/.test(ua) && (v = [RegExp.$1, RegExp.$2])) ?
        'ie ie' + v[0] + ' ie' + v[0] + '_' + v[1] + ' ie9m' :
        /* FF */
        (/firefox\/(\d+)\.(\d+)/.test(ua) && (re = RegExp)) ?
          g + ' firefox firefox' + re.$1 + ' firefox' + re.$1 + '_' + re.$2 :
          is('gecko/') ? g :
            /* Opera */
            is(o) ? o + (/version\/(\d+)/.test(ua) ? ' ' + o + RegExp.$1 :
              (/opera(\s|\/)(\d+)/.test(ua) ? ' ' + o + RegExp.$2 : '')) :
              /* K */
              is('konqueror') ? 'konqueror' :
                /* Black Berry */
                is('blackberry') ? m + ' blackberry' :
                  /* Chrome */
                  (is(c) || is('crios')) ? w + ' ' + c :
                    /* Iron */
                    is('iron') ? w + ' iron' :
                      /* Safari */
                      !is('cpu os') && is('applewebkit/') ? w + ' ' + s :
                        /* Mozilla */
                        is('mozilla/') ? g : '',
    /* Android */
    is('android') ? m + ' android' : '',
    /* Tablet */
    is('tablet') ? 'tablet' : '',
    /* Machine */
    is('j2me') ? m + ' j2me' :
      is('ipad; u; cpu os') ? m + ' chrome android tablet' :
        is('ipad;u;cpu os') ? m + ' chromedef android tablet' :
          is('iphone') ? m + ' ios iphone' :
            is('ipod') ? m + ' ios ipod' :
              is('ipad') ? m + ' ios ipad tablet' :
                is('mac') ? 'mac' :
                  is('darwin') ? 'mac' :
                    is('webtv') ? 'webtv' :
                      is('win') ? 'win' + (is('windows nt 6.0') ? ' vista' : '') :
                        is('freebsd') ? 'freebsd' :
                          (is('x11') || is('linux')) ? 'linux' : '',
    /* Ratio (Retina) */
    (r != '1') ? ' retina ratio' + r : '',
    'js portrait'].join(' ');
  if(window.jQuery && !window.jQuery.browser) {
    window.jQuery.browser = v ? {msie: 1, version: v} : {};
  }
  document.documentElement.className += ' ' + res;
};
css_browser_selector(navigator.userAgent);


/* str_replace (faiq agayev[faiqagayev.com])*/
(function(window,$,undefined){
	window.str_replace = function($search,$replace,str)
	{
		if($search===undefined || $replace===undefined)return '';

		if(typeof($search)=='object' && typeof($replace)=='object')
			for(i=0;i<$search.length;i++)
				str = str_replace($search[i],$replace[i],str);

		else if(typeof($search)=='object')
			for(i=0;i<$search.length;i++)
				str = str_replace($search[i],$replace,str);

		else //while(str.indexOf($search)!=-1)
			str=str.toString().replace(new RegExp($search,'gi'),$replace);

		return str;
	}
	if(String.prototype.str_replace==null)String.prototype.str_replace = function($search,$replace)
	{
		return str_replace($search,$replace,this);
	}
	$.extend({
		str_replace : function($search,$replace,$str) {
			return str_replace($search,$replace,$str);
		}
	});
	$.fn.str_replace = function($search,$replace)
	{
		$(this).val(str_replace($search,$replace,$(this).val()));
	};
})(window,jQuery);
/* str_replace end*/

$(document).ready(()=>{

  if($('#sc1').length>0)$('body').addClass('home');

  $('body').on('click','.open_popup',function(e){
    e.preventDefault();
    if($(this).attr('data-target'))$($(this).attr('data-target')).openPopup();
  });

  $('body').on('click','.popup a.close',function(e){
    e.preventDefault();
    $(this).closest('.popup').closePopup();
  });

  //tabs
  $('body').on('click','.tabs[data-target] > *:not(.active)',function(e){
    e.preventDefault();
    const tab_parent =  $(this).closest('.tabs'),
      target = tab_parent.attr('data-target');
    if(tab_parent.length > 0 && target){

      const tab = $(this),
        tabs = tab_parent.find('>*'),
        index = tabs.index(tab),
        content = $(target).find('>*');

      tabs.removeClass('active');
      content.removeClass('active');

      tab.addClass('active');
      content.eq(index).addClass('active');
    }
  });


  $("form.validation").validationEngine({
    showPrompts:false,
    addFailureCssClassToField:"error"
  });

  $('[data-mask]').each(function(){
    const type = $(this).data('mask');
    switch (type){
      case "phone":
        $(this).inputmask({
            showMaskOnHover:false,
          mask: "(*) 999 - 99 - 99",
          definitions: {
            '9': {
              validator: "[0-9]",
              cardinality: 1,
              casing: "lower"
            },
            '*':{
              validator:"(10|50|51|55|60|70|77|99)",
              cardinality: 2,
            }
          }
        });
        break;
      case "number":
      case "decimal":
      case "integer":
        $(this).inputmask(type, { rightAlign: false });
        break
    }
  });

  $('[data-maps]').each(function(){
    const id = $(this).attr('id');
    const coords = {lat:$(this).attr('data-lat')*1,lng:$(this).attr('data-lng')*1};
    const zoom = $(this).attr('data-zoom') ? $(this).attr('data-zoom')*1 : 11;
    $.maps.load(()=>{
      const map = new google.maps.Map(document.getElementById(id), {
        zoom: zoom,
        center: coords
      });
      const marker = new google.maps.Marker({
        position: coords,
        icon:'/images/map/select_map_pin.png'
      });
      // adds the marker on the map
      marker.setMap(map);
    });
  });

  $('[data-match-height]').each(function () {
    $(this).find($(this).attr('data-match-height')).matchHeight();
  });

  $('#header .search .toggle').off('click').on('click', function(){
    if($('#header .search').hasClass('open')){
      $('#header .search').removeClass('open');
    }
    else {
      $('#header .search').addClass('open');
    }
  });

  if($('#sc2').length>0){
    $('#sc2 .owl-carousel').owlCarousel({
      margin:0,
      responsiveClass:true,
      nav:true,
      dots:false,
      navText:['',''],
      responsive:{
        0:{
          items:1,
        },
        991:{
          items:3,
        }
      }
    });
  }
  if($('#sc3').length>0){
    $('#sc3 .owl-carousel').owlCarousel({
      loop:true,
      margin:0,
      responsiveClass:true,
      nav:true,
      dots:false,
      navText:['',''],
      responsive:{
        0:{
          items:1,
        },
        991:{
          items:3,
        }
      }
    });
  }

	if($('.news_page .owl-carousel').length>0){
		$('.news_page .owl-carousel').owlCarousel({
			margin:20,
			responsiveClass:true,
			nav:true,
			dots:false,
			navText:['',''],
			responsive:{
				0:{
					items:2,
				},
				550:{
					items:3,
				},
			}
		});
	}

    if($('.cafe_restorans .owl-carousel').length>0){
        $('.cafe_restorans .owl-carousel').owlCarousel({
            margin:25,
            responsiveClass:true,
            nav:true,
            dots:false,
            navText:['',''],
            responsive:{
                0:{
                    items:1,
                },
                550:{
                    items:3,
                },
            }
        });
    }

    $('.tourism_statistics .item label').click(function(){
        const item = $(this).closest('.item');
        if(!item.hasClass('open'))$('.tourism_statistics .open').not(item).removeClass('open');
        item.toggleClass('open');
    });

	const media = window.matchMedia("(max-width: 991px)");
	mobileSupport(media);
	media.addListener(mobileSupport);
});
$.fn.openPopup = function(){
  const elem = $(this);
  if(elem.length>0) {
    const opened_popup = $('.popup').filter('.show');

    if(opened_popup.length)opened_popup.closePopup();

    elem.addClass('show');
    setTimeout(() => elem.addClass('animate'), 1);
    elem.trigger('openPopup');
  }
};
$.fn.closePopup = function(){
  const elem = $(this);
  if(elem.length>0) {
    elem.removeClass('animate');
    setTimeout(()=>elem.removeClass('show'),400);
    elem.trigger('closePopup');
  }
};

$.maps = {
  key:window.MAPS_API_KEY,
  loaded: false,
  loading: false,
  callbacks : [],
  load(callback){
    $.maps.add_callback(callback);
    if($.maps.loaded)$.maps.run_callback();
    else if(!$.maps.loading){
      $.maps.loading = true;
      $.getScript('https://maps.googleapis.com/maps/api/js?key='+ $.maps.key +'&callback=$.maps.ready&language=az&region=AZ');
    }
  },
  ready(){
    $.maps.loaded = true;
    $.maps.run_callback();
  },
  add_callback(fn){
    if(typeof fn !== 'undefined')$.maps.callbacks.push(fn);
  },
  run_callback(){
    if($.maps.callbacks.length>0){
      $.each($.maps.callbacks,(index,callback)=>{
        if($.isFunction(callback))callback();
        else if(typeof window[callback] !== "undefined")window[callback]();
      });
      $.maps.callbacks = [];
    }
  }
};

$.is_mobile = false;
const mobileSupport = media => {
  if (media.matches){
    $.is_mobile = true;
		console.log('sdf');
		$('#header .social').appendTo('#header nav');
		$('#header .lang').appendTo('#header nav');

    $(document).trigger('mobile_on');
  }
  else{
    $.is_mobile = false;

		$('#header .social').appendTo('#header .top');
		$('#header .lang').appendTo('#header .top');

    $(document).trigger('mobile_off');
  }
};